import React, { type ReactNode } from 'react';
import { tv } from '@/utils/tv';

const chip = tv({
  base: 'flex shrink-0 cursor-pointer items-center gap-1 rounded-xl bg-purple-soft py-0.5 text-caption-12 whitespace-nowrap text-primary transition-colors hover:bg-secondary active:bg-secondary-pressed contrast:border contrast:border-border',
  variants: {
    hasIcon: {
      true: 'pr-2 pl-1',
      false: 'px-2',
    },
  },
});

interface Props {
  label: string;
  icon?: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const DiaryActionChip: React.FC<Props> = ({
  label,
  icon,
  className,
  onClick,
}) => (
  <button
    type="button"
    className={chip({ hasIcon: !!icon, className })}
    onClick={onClick}
  >
    {icon}
    {label}
  </button>
);
